const CivilIcon = () => {
  return (
    <svg viewBox="0 0 30 30">
      <path
        d="M11.036,5.27l-.441.421-4.9,4.9-.421.441.421.441,9.579,9.579L7.587,28.737a.627.627,0,0,0-.172.268L6.189,33.6a.613.613,0,0,0,.747.747l4.6-1.226a.627.627,0,0,0,.268-.172L32.99,11.764l.5-.5a2.98,2.98,0,1,0-4.214-4.214L21.055,15.27,11.476,5.691Zm0,1.743,1,1-.785.785.881.881.785-.785.958.958-1.4,1.4.881.881,1.4-1.4.958.958-.785.785.881.881.785-.785.958.958-1.4,1.4.881.881,1.4-1.4.958.958-.785.785.785.785-3.237,3.237L7.013,11.036Zm18.6,1.4,2.49,2.491L11.055,31.974l-2.49-2.49ZM25.787,20.02l-.441.421L24.12,21.668l.881.881.785-.785.958.958-1.4,1.4.881.881,1.4-1.4.958.958-.785.785.881.881.785-.785.958.958-1.4,1.4.881.881,1.4-1.4.958.958-.785.785.881.881.785-.785.383.383L29.5,33.526l-8.621-8.6-.862.862,9.042,9.061.441.421.441-.421,4.9-4.9.421-.441-.421-.441Z"
        transform="translate(-5.27 -5.27)"
      />
    </svg>
  );
};

export default CivilIcon;
